angular.module('picmonic-common').factory('MathUtils', function () {
  return {
    safeRound: function (number, roundMultiplier = 1e10) {
      return !number ? number : Math.round(number * roundMultiplier) / roundMultiplier;
    },
  };
});
